/**
 * NOTE: The goal of this file is to load in all of the dependent
 * font-awesome icons and add them to the `library`.
 * This helps us keep track of all the loaded font-awesome icons
 * in a single file, and they get loaded upon bootstrap cycle of the app.
 */

import { library } from '@fortawesome/fontawesome-svg-core';

import { faBug } from '@fortawesome/free-solid-svg-icons/faBug';
import { faGear } from '@fortawesome/free-solid-svg-icons/faGear';
import { faComment } from '@fortawesome/free-solid-svg-icons/faComment';
import { faComments } from '@fortawesome/free-solid-svg-icons/faComments';
import { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons/faFilePdf';
import { faFax } from '@fortawesome/free-solid-svg-icons/faFax';
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone';
import { faShareFromSquare } from '@fortawesome/free-solid-svg-icons/faShareFromSquare';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons/faCircleXmark';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faFileWord } from '@fortawesome/free-solid-svg-icons/faFileWord';
import { faFlag } from '@fortawesome/free-solid-svg-icons/faFlag';
import { faClockRotateLeft } from '@fortawesome/free-solid-svg-icons/faClockRotateLeft';
import { faList } from '@fortawesome/free-solid-svg-icons/faList';
import { faShare } from '@fortawesome/free-solid-svg-icons/faShare';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons/faTrashCan';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faRetweet } from '@fortawesome/free-solid-svg-icons/faRetweet';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons/faPenToSquare';
import { faUserXmark } from '@fortawesome/free-solid-svg-icons/faUserXmark';
import { faListUl } from '@fortawesome/free-solid-svg-icons/faListUl';
import { faLinkSlash } from '@fortawesome/free-solid-svg-icons/faLinkSlash';
import { faSquarePlus } from '@fortawesome/free-solid-svg-icons/faSquarePlus';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons/faTriangleExclamation';

// Build a font-awesome icons library.
library.add(
    faBug,
    faComment,
    faComments,
    faGear,
    faCopy,
    faFax,
    faFilePdf,
    faFileWord,
    faFlag,
    faClockRotateLeft,
    faList,
    faPhone,
    faShare,
    faTrashCan,
    faShareFromSquare,
    faCircleXmark,
    faEye,
    faDownload,
    faEnvelope,
    faRetweet,
    faPenToSquare,
    faUserXmark,
    faListUl,
    faLinkSlash,
    faSquarePlus,
    faUser,
    faTriangleExclamation
);
